import { isDefined, isNonEmpty } from '@sgme/fp';
import { GreeksTablesMenu } from 'components/shared/Sensitivity/Greeks/FICCGreeks';
import { Greeks } from 'components/shared/Sensitivity/Greeks/Greeks';
import { connect } from 'react-redux';
import type { WorkspaceTabOwnProps } from 'shared/connect/connect';
import type { FICCGreek, GreeksTable } from 'state/quotes/details/details.model';
import { getFormQuoteDetails } from 'state/selectors/common/commonForm';
import { getGreeks, hasGreeks } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';
import { getUserPreferencesGreeksPrecision } from 'state/userPreferences/userPreferences.selectors';

interface GreeksProps {
  hasGreeks: boolean;

  greeks?: GreeksTable;

  precisionGreeks?: number;
  ficcGreeks?: Readonly<FICCGreek[]>;
}

const mapStateToProps = (state: AppState, { formId, workspace }: WorkspaceTabOwnProps): GreeksProps => {
  const quoteDetails = getFormQuoteDetails(state, workspace, formId);
  return {
    hasGreeks: hasGreeks(state, workspace, formId),
    greeks: getGreeks(state, workspace, formId),
    precisionGreeks: getUserPreferencesGreeksPrecision(state),
    ficcGreeks: quoteDetails?.FICCGreeks,
  };
};

export const ConnectedGreeks = connect(mapStateToProps)(GreeksSection);

function GreeksSection({ greeks, hasGreeks, precisionGreeks, ficcGreeks }: GreeksProps) {
  if (!hasGreeks) {
    return;
  }
  if (isNonEmpty(ficcGreeks)) {
    return <GreeksTablesMenu greeks={ficcGreeks} greeksPrecision={precisionGreeks ?? 4} />;
  } else if (isDefined(greeks)) {
    return (
      <Greeks
        data={greeks}
        precision={precisionGreeks ?? 4}
        copyActionName="Copy greek"
        noGreeksMessageKey="quoteDetails.NoGreeksAvailable"
      />
    );
  }
}
